import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Checkbox, IconButton, Box, Typography } from '@material-ui/core';
import data from '../segments/data';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Delete from '../assets/icons/primary-blue-bin.png'
import IconRadiusButton from '../CustomizedUIs/IconRadiusButton';
import colors from '../CustomizedUIs/Colors';
import { useTranslate } from 'react-admin';


const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.primary.main,
        paddingTop: '16px',
        paddingBottom: '16px',
        borderBottom: 'solid 5px ' + theme.palette.background.default,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);



const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 600,
    },
    tableCell: {
        width: 50,
        borderBottom: 'solid 5px ' + theme.palette.background.default
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
        color: 'white'
    },
    tableSortLabel: {
        color: theme.palette.common.white,
        '&:hover': {
            color: 'white'
        },
        '&:focus': {
            color: 'white'
        },
    }
}));

const headCells = [
    { id: 'name', numeric: false, disablePadding: true, label: 'Name' },
    { id: 'internalName', numeric: false, disablePadding: false, label: 'Internal name' },
    { id: 'type', numeric: false, disablePadding: false, label: 'Type' },
    { id: 'number', numeric: false, disablePadding: false, label: 'Number' },
    { id: 'epgId', numeric: false, disablePadding: false, label: 'Epg id' },
    { id: '', numeric: false, disablePadding: false, label: '' }
];

function EnhancedTableHead(props) {
    const { classes } = props;


    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    (
                        <StyledTableCell
                            key={'cell-' + headCell.id}

                        >
                            <TableSortLabel
                                className={classes.tableSortLabel}
                            >
                                {headCell.label}

                            </TableSortLabel>
                        </StyledTableCell>
                    )
                ))}
            </TableRow>
        </TableHead>
    );
}



function ChannelsTable({ readOnly, data, style, setData, handleDelete }) {
    const classes = useStyles();
    const translate = useTranslate();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [orderBy, setOrderBy] = useState('ipAddress');
    const [order, setOrder] = React.useState('desc');

    const onDragEnd = result => {
        const { destination, source, reason } = result;

        // Not a thing to do...
        if (!destination || reason === 'CANCEL') {

            return;
        }

        if (
            destination.droppableId === source.droppableId &&
            destination.index === source.index
        ) {
            return;
        }

        const list = Object.assign([], data);
        const project = data[source.index];
        list.splice(source.index, 1);
        list.splice(destination.index, 0, project);
        setData(list)
    }


    const getItemStyle = (isDragging, draggableStyle) => {
        return {
            // some basic styles to make the items look a bit nicer
            ...draggableStyle,
            ...(isDragging && {
                background: "rgb(235,235,235)"

            }),

        }
    }

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                    <Table size='small' aria-label="sticky table">
                        <EnhancedTableHead style={style} classes={classes} />
                        {
                            data.length === 0 ?
                                <TableBody>
                                    <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell>
                                            <Box width='100%' display='flex' justifyContent='center' p={2}>
                                                <Typography variant='h5'>{translate(`pos.common.noData`)}</Typography>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                                :
                                <Droppable droppableId='channelsTable'>
                                    {
                                        ((provided, snapshot) => (

                                            <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                                                {
                                                    data.map((item, index) => (
                                                        <Draggable
                                                            key={item.id}
                                                            draggableId={item.id.toString()}
                                                            index={index}>
                                                            {
                                                                (provided, snapshot) => (

                                                                    <TableRow key={'table-row-' + index}
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                        style={getItemStyle(
                                                                            snapshot.isDragging,
                                                                            provided.draggableProps.style
                                                                        )}
                                                                    >
                                                                        <TableCell className={classes.tableCell}>{item.name}</TableCell>
                                                                        <TableCell className={classes.tableCell}>{item.internalName}</TableCell>
                                                                        <TableCell className={classes.tableCell}>{item.type}</TableCell>
                                                                        <TableCell className={classes.tableCell}>{item.number}</TableCell>
                                                                        <TableCell className={classes.tableCell}>{item.epgId}</TableCell>
                                                                        <TableCell className={classes.tableCell} align='right'>
                                                                            <Box hidden={readOnly}>
                                                                                <IconRadiusButton onClick={() => handleDelete(item, index)}
                                                                                    style={{ width: 30, height: 30, padding: 0 }} bgColor={colors.lightBlue['100']}>
                                                                                    <img src={Delete} width={15}></img>
                                                                                </IconRadiusButton>
                                                                            </Box>

                                                                        </TableCell>
                                                                    </TableRow>

                                                                )
                                                            }
                                                        </Draggable>


                                                    ))
                                                }
                                                {provided.placeholder}
                                            </TableBody>

                                        ))
                                    }

                                </Droppable>

                        }

                    </Table>
                </TableContainer>

            </Paper>
        </DragDropContext>
    );
}

export default ChannelsTable;
